import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import Moment from 'moment';
import { getActiveLanguage } from '@haldor/ui';
var FromNow = /*#__PURE__*/function (_Component) {
  function FromNow() {
    _classCallCheck(this, FromNow);
    return _callSuper(this, FromNow, arguments);
  }
  _inherits(FromNow, _Component);
  return _createClass(FromNow, [{
    key: "icon",
    value: function icon() {
      return /*#__PURE__*/React.createElement("svg", {
        id: "Lager_1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        xmlSpace: "preserve",
        viewBox: "0 0 12 12"
      }, /*#__PURE__*/React.createElement("style", {
        type: "text/css"
      }, '.st0{fill:none;stroke:#1D1D1B;stroke-width:1.2756;stroke-linecap:round;stroke-miterlimit:10;}'), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
        className: "st0",
        cx: "6",
        cy: "6.7",
        r: "4.4"
      }), /*#__PURE__*/React.createElement("line", {
        className: "st0",
        x1: "6",
        y1: "3.9",
        x2: "6",
        y2: "6.7"
      }), /*#__PURE__*/React.createElement("line", {
        className: "st0",
        x1: "6",
        y1: "2.1",
        x2: "6",
        y2: "1.1"
      }), /*#__PURE__*/React.createElement("line", {
        className: "st0",
        x1: "5.1",
        y1: "0.8",
        x2: "6.9",
        y2: "0.8"
      }), /*#__PURE__*/React.createElement("line", {
        className: "st0",
        x1: "6",
        y1: "6.7",
        x2: "7.3",
        y2: "5.6"
      }), /*#__PURE__*/React.createElement("line", {
        className: "st0",
        x1: "9.4",
        y1: "3.8",
        x2: "10.1",
        y2: "3.2"
      })));
    }
  }, {
    key: "capitalizeFirstLetter",
    value: function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  }, {
    key: "formatDate",
    value: function formatDate() {
      Moment.locale(getActiveLanguage());
      return this.capitalizeFirstLetter(Moment.utc(this.props.children).local().fromNow());
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("time", {
        className: "from-now card-meta",
        dateTime: this.props.children
      }, this.icon(), this.formatDate());
    }
  }]);
}(Component);
export { FromNow as default };